import { Sides } from "@project/emerge-types";

export const SidesNames: { [key in Sides]: string } = {
  [Sides.LEFT]: "li",
  [Sides.RIGHT]: "re",
  [Sides.BACK]: "hi",
  [Sides.FRONT]: "vo",
  [Sides.BOTTOM]: "bo",
  [Sides.TOP]: "de",
};
